import { Settings } from 'luxon'
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { offlineDb } from './db'
import { parseDateTimes } from '../utilities/helpers/parseDateTimes'

export const ECLIPSE_TZ_KEY = 'eclipse_tz'

const cachedTz = localStorage.getItem(ECLIPSE_TZ_KEY)
if (cachedTz) Settings.defaultZone = cachedTz

const dexieStorage = {
  getItem: async (key: string): Promise<string | null> => {
    const entry = await offlineDb.queryCache.get(key)
    return entry?.value ?? null
  },
  setItem: async (key: string, value: string): Promise<void> => {
    await offlineDb.queryCache.put({ key, value })
  },
  removeItem: async (key: string): Promise<void> => {
    await offlineDb.queryCache.delete(key)
  },
}

export const asyncPersister = createAsyncStoragePersister({
  storage: dexieStorage,
  key: 'ECLIPSE_QUERY_CACHE',
  throttleTime: 0,
  deserialize: (cachedString) => {
    const parsed = JSON.parse(cachedString)
    parsed?.clientState?.queries?.forEach((query: any) => {
      if (query?.state?.data != null) {
        parseDateTimes(query.state.data)
      }
    })
    return parsed
  },
})
